var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllImages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75.07 76.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "alle_bilderElement 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2-2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "66.15 16.7 60.82 52.67 60.9 53.93 71.93 18.38 66.15 16.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.07,16.69,66.52,14.2l.41-2.77-8.77-.92L58,8l-10.18.72L17.69,0l-2,6L7.4,5.16l-.73,6.55L0,12.19,3.5,75,36.88,73l19.48,4L58,71.65l4-.25-.66-10.46ZM19.31,3.07l18,5.24-19-2ZM9.61,7.91l5.27.55,1,.11,14,1.47L9.2,11.52Zm45,66.17-8.27-1.71,9-.56Zm1.66-5.33L35.2,70.06l-8.92.56-20,1.23L3.16,15l3.17-.23,2.54-.19h.18l37.86-2.7,2-.15,6.27-.45.09,1.48.05.84L58,54.94l.45,7,.3,4.73.12,1.88Zm2.1-54.3L58.32,13l5.75.6L63.72,16,60.06,40.71Zm2.42,38.22,5.33-36,5.78,1.68-11,35.55Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllImages);
export default __webpack_public_path__ + "static/media/all_images.297c242cf41ab75092392c0765079469.svg";
export { ForwardRef as ReactComponent };